import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import debounce from 'react-utils/debounce';
import SearchSelect from '../../../components/SearchSelect';
import { getLocations } from '../autocomplete';

const mapLocationToOption = ({
  displayName,
  gplaceId
}) => ({
  text: displayName,
  value: gplaceId
});

const mapOptionToLocation = ({
  text,
  value
}) => ({
  displayName: text,
  gplaceId: value
});

const loadPredictions = debounce((input, callback) => {
  return input ? getLocations(input).then(locations => {
    callback(null, {
      options: locations.map(({
        description,
        place_id
      }) => ({
        text: description,
        value: place_id
      })),
      pagination: {}
    });
  }) : callback(null);
}, 500);

const GoogleLocationSelect = ({
  value,
  placeholder,
  onChange = () => {}
}) => {
  const valueAsOption = value ? mapLocationToOption(value) : null;

  const handleChange = v => {
    onChange(v ? mapOptionToLocation(v) : null);
  };

  return /*#__PURE__*/_jsx(SearchSelect, {
    "aria-label": I18n.text('connectDotCom.locationSearch'),
    "data-test-id": "location-autocomplete-input",
    placeholder: placeholder,
    onChange: handleChange,
    value: valueAsOption,
    loadOptions: loadPredictions
  });
};

export default GoogleLocationSelect;